module.exports = {
    min_char: 'Minst {amount} tecken!'
}